export default __webpack_public_path__ + "static/media/img-4.dc055814.jpg";